import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type {
  RequestsStore,
  Sorting,
  Filters,
  PageInfo,
  Request,
} from './types'

const initialState: RequestsStore = {
  items: [],
  item: {},
  pageInfo: null,
  sorting: {
    type: null,
    name: null,
    value: null,
  },
  loading: true,
  error: null,
  query: '',
  filters: [],
  selectedItems: [],
}

const requestsSlice = createSlice({
  name: 'request-wines',
  initialState,
  reducers: {
    setItems: (state, { payload }: PayloadAction<Request[]>) => {
      state.items = payload
    },
    setPageInfo: (state, { payload }: PayloadAction<PageInfo>) => {
      state.pageInfo = payload
    },
    setSelectedItems: (state, { payload }: PayloadAction<Request>) => {
      state.selectedItems = payload
    },
    setSort: (state, { payload }: PayloadAction<Sorting | null>) => {
      state.sorting = payload
    },
    setRequest: (state, { payload }: PayloadAction<Partial<Request>>) => {
      state.item = { ...state.item, ...payload }
    },
    clear: () => {
      return initialState
    },
    setLoading: (state, { payload }) => {
      state.loading = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setQuery: (state, { payload }: PayloadAction<string>) => {
      state.query = payload
      state.pageInfo = {
        ...state.pageInfo,
        page: 1,
      }
    },
    setFilters: (state, { payload }: PayloadAction<Filters>) => {
      state.filters = payload
      state.pageInfo = {
        ...state.pageInfo,
        page: 1,
      }
    },
  },
})

export const { actions, reducer: requestWines } = requestsSlice
export const {
  setItems,
  setPageInfo,
  setSelectedItems,
  setSort,
  setRequest,
  clear,
  setLoading,
  setQuery,
  setFilters,
  setError,
} = actions
